export default {
  label: {
    title: {
      hiddeCard: 'Componente ocultado',
    },
    description: 'Seguindo as normas da Lei Geral de Proteção de Dados Pessoais (LGPD), não é possível visualizar componentes com dados que expõem a identidade dos autores das publicações. Como este dashboard está compartilhado com usuários convidados, o componente que você está adicionando agora será ocultado do compartilhamento. Para ver a lista de componentes ocultados, acesse a área de Compartilhamento.',
    button: {
      aboutSharing: 'Sobre o compartilhamento',
      confirm: 'Entendi',
      cancel: 'Cancelar',
    },
  },
};
